import { useCallback } from 'react'
import { useRecoilState } from 'recoil'

import {CUSTOM_SERIES, CustomSeries, Minutes, Period, Tool} from '../enums'

import { useChartRef } from '../context'
import {chartState} from "../store/chart";
import useIndicator from "./useIndicator";

export default function useChartOptions() {
  const { chart } = useChartRef()
  const [option, setOption] = useRecoilState(chartState)
  const { handleSmaDisable } = useIndicator()

  const handleOption = useCallback(_handleOption, [setOption])
  const handlePeriod = useCallback(_handlePeriod, [setOption])
  const handleMinutes = useCallback(_handleMinutes, [setOption])
  const handleCustomSeries = useCallback(_handleCustomSeries, [
    setOption,
    chart,
  ])
  const handleTool = useCallback(_handleTool, [setOption])

  return {
    option,
    handleOption,
    handlePeriod,
    handleMinutes,
    handleCustomSeries,
    handleTool,
  }

  function _handleOption(key: string, value: string | boolean) {
    setOption((prev) => ({ ...prev, [key]: value }))
  }

  function _handlePeriod(period: Period) {
    setOption((prev) => ({ ...prev, period }))
  }

  function _handleMinutes(minutes: Minutes) {
    setOption((prev) => ({ ...prev, period: 'minutes', minutes }))
  }

  function _handleCustomSeries(value: CustomSeries) {
    chart?.removeAnnotations?.()

    if (value === CUSTOM_SERIES.DRAW_SMA) {
      handleSmaDisable(false)
    } else {
      handleSmaDisable(true)
    }

    setOption((prev) => ({
      ...prev,
      customSeries: value,
    }))
  }

  function _handleTool(value: Tool) {
    setOption((prev) => ({
      ...prev,
      tool: value,
    }))
  }
}
